<script setup>
  defineProps({
    product: Object,
  });
</script>
<template>
  <dl class="products-specification">
    <div class="products-specification__item" v-for="attribute in product.list_attributes">
      <dt class="products-specification__title">{{ attribute.name }}</dt>
      <dd class="products-specification__details">{{ attribute.value }}</dd>
    </div>
  </dl>
</template>
<style scoped lang="scss">
  .products-specification {
    display: grid;
    grid-template-columns: 1fr;
    column-gap: 2rem;
    width: 100%;

    &__item {
      display: grid;
      grid-template-columns: 2fr 3fr;
      justify-content: space-between;
      column-gap: 1rem;
      padding: 0.75rem 1rem;
      line-height: 1.5;
      font-size: 0.875rem;

      &:nth-child(even) {
        background-color: var(--color-light-gray);
      }
    }

    &__title {
      font-weight: var(--font-weight-700);

      &::after {
        content: ':';
      }
    }
  }

  @media (max-width: 768px) {
    .products-specification {
      grid-template-columns:1fr;

      &__item {
        grid-template-columns: 1fr;
        padding: 0.5rem 1rem;
        font-size: 0.75rem;

        &:nth-child(even) {
          background-color: var(--color-primary-body-background);
        }

        &:nth-child(odd) {
          background-color: var(--color-light-gray);
        }
      }
    }
  }
</style>
